var sony_V164G_TV = {
    name: "V164G_TV",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,45,187,196],
        },
        {
            function: "KEY_EJECTCD",
            name: "KEY_EJECTCD",
            icon: "KEY_EJECTCD",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,46,215,98],
        },
        {
            // function: "TV/VTR",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,45,219,196],
        },
        {
            function: "TIMER_CLEAR",
            name: "TIMER_CLEAR",
            icon: "TIMER_CLEAR",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,58,190,196],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,55,94,196],
        },
        {
            function: "COUNTER_RESET",
            name: "COUNTER_RESET",
            icon: "COUNTER_RESET",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,46,175,98],
        },
        {
            function: "ARROW_UP",
            name: "ARROW_UP",
            icon: "ARROW_UP",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,55,213,162],
        },
        {
            function: "ARROW_DOWN",
            name: "ARROW_DOWN",
            icon: "ARROW_DOWN",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,58,175,98],
        },
        {
            function: "ARROW_LEFT",
            name: "ARROW_LEFT",
            icon: "ARROW_LEFT",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,45,95,98],
        },
        {
            function: "ARROW_RIGHT",
            name: "ARROW_RIGHT",
            icon: "ARROW_RIGHT",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,53,95,98],
        },
        {
            function: "EXECUTE",
            name: "EXECUTE",
            icon: "EXECUTE",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,53,111,98],
        },
        {
            function: "AUDIO_MONITOR",
            name: "AUDIO_MONITOR",
            icon: "AUDIO_MONITOR",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,42,221,226],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [26,0,4,140,2,18,2,170,9,18,2,227,4,18,2,140,2,132,100,127,158,32],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,47,239,16],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,55,239,16],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,43,247,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,59,239,16],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,45,247,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,53,247,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,42,251,196],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,61,239,16],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,46,247,136],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,55,189,136],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,43,123,196],
        },
        {
            function: "DISPLAY",
            name: "DISPLAY",
            icon: "DISPLAY",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,54,173,226],
        },
        {
            function: "TRACKIG_AUTO/MANUAL",
            name: "TRACKIG_AUTO/MANUAL",
            icon: "TRACKIG_AUTO/MANUAL",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,61,110,196],
        },
        {
            function: "TRACKIG_DOWN",
            name: "TRACKIG_DOWN",
            icon: "TRACKIG_DOWN",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,54,175,98],
        },
        {
            function: "TRACKIG_UP",
            name: "TRACKIG_UP",
            icon: "TRACKIG_UP",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,59,213,162],
        },
        {
            function: "SLOW_-",
            name: "SLOW_-",
            icon: "SLOW_-",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,47,221,136],
        },
        {
            function: "SLOW_+",
            name: "SLOW_+",
            icon: "SLOW_+",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,55,221,136],
        },
        {
            function: "TAPE_SPEED",
            name: "TAPE_SPEED",
            icon: "TAPE_SPEED",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,42,239,98],
        },
        {
            function: "FRAME_PREVIOUS",
            name: "FRAME_PREVIOUS",
            icon: "FRAME_PREVIOUS",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,62,181,162],
        },
        {
            function: "FRAME_NEXT",
            name: "FRAME_NEXT",
            icon: "FRAME_NEXT",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,53,119,98],
        },
        {
            function: "INDEX_SEARCH_PREVIOUS",
            name: "INDEX_SEARCH_PREVIOUS",
            icon: "INDEX_SEARCH_PREVIOUS",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,61,189,136],
        },
        {
            function: "INDEX_SEARCH_NEXT",
            name: "INDEX_SEARCH_NEXT",
            icon: "INDEX_SEARCH_NEXT",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,46,222,196],
        },
        {
            function: "INPUT_SELECT",
            name: "INPUT_SELECT",
            icon: "INPUT_SELECT",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,62,189,136],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,55,174,196],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,55,119,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,43,187,196],
        },
        {
            function: "CH_+",
            name: "CH_+",
            icon: "CH_+",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,62,239,16],
        },
        {
            function: "CH_-",
            name: "CH_-",
            icon: "CH_-",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,47,119,136],
        },
        {
            function: "SEARCH_RW",
            name: "SEARCH_RW",
            icon: "SEARCH_RW",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,61,181,162],
        },
        {
            function: "SEARCH_FF",
            name: "SEARCH_FF",
            icon: "SEARCH_FF",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,53,183,98],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,53,215,98],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [26,0,4,227,4,18,2,140,2,18,2,170,9,18,2,140,2,132,100,45,215,98],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [26,0,4,140,2,18,2,227,4,18,2,170,9,18,2,140,2,132,100,61,117,162],
        },
    ]
}
export default sony_V164G_TV